import api from '@services/api';
import { Client, ClientSearchInput } from '../models/client';
import { PaginationResponse } from '../models/pagination';

/**
 * <p>
 * API endpoints that cover all person related CRUD calls
 */

export const ClientApi = api.injectEndpoints({
  endpoints: (builder) => ({
    searchClient: builder.query<PaginationResponse<Client>, ClientSearchInput>({
      query: (input: ClientSearchInput) => ({
        url: encodeURI(
          `/indirect/client/search?searchTerm=${input.searchTerm}&page=${input.page}&size=${input.size}&sortKey=${input.sortKey}&sortDirection=${input.sortDirection}`,
        ),
      }),
      providesTags: ['Client'],
    }),
  }),
});

export const { useSearchClientQuery } = ClientApi;
